namespace Gamification.Gamification {
    export interface UtentiProdottiBadgeRow {
        IdUtenteProdottoBadge?: number;
        UserId?: number;
        TenantId?: number;
        IdUtente?: number;
        IdUtenteProdotto?: number;
        IdProdottoBadge?: number;
        DataOra?: string;
        ImmagineOttenuto?: string;
        ImmagineOttenutoNomeFile?: string;
        Stato?: number;
        IdProdottoBadgeNome?: string;
        IdProdottoBadgeDescrizione?: string;
    }

    export namespace UtentiProdottiBadgeRow {
        export const idProperty = 'IdUtenteProdottoBadge';
        export const localTextPrefix = 'Gamification.UtentiProdottiBadge';
        export const lookupKey = 'Gamification.UtentiProdottiBadge';

        export function getLookup(): Q.Lookup<UtentiProdottiBadgeRow> {
            return Q.getLookup<UtentiProdottiBadgeRow>('Gamification.UtentiProdottiBadge');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            IdUtenteProdottoBadge = "IdUtenteProdottoBadge",
            UserId = "UserId",
            TenantId = "TenantId",
            IdUtente = "IdUtente",
            IdUtenteProdotto = "IdUtenteProdotto",
            IdProdottoBadge = "IdProdottoBadge",
            DataOra = "DataOra",
            ImmagineOttenuto = "ImmagineOttenuto",
            ImmagineOttenutoNomeFile = "ImmagineOttenutoNomeFile",
            Stato = "Stato",
            IdProdottoBadgeNome = "IdProdottoBadgeNome",
            IdProdottoBadgeDescrizione = "IdProdottoBadgeDescrizione"
        }
    }
}
